<div class="modal-body height-500 width-500">
  <div class="layout-auto-1-auto">
    <h5 class="modal-header">{{getHeader()}}</h5>
    <div class="content modal-form">
      <form #inputForm="ngForm">
        <div class="grid cols-1">
          <exg-input [maxlength]="256" [(ngModel)]="libName" [required]="true" caption="{{getRessource('Name')}}" name="libraryName"></exg-input>
          <exg-textarea [maxlength]="512" [(ngModel)]="libComment" caption="{{getRessource('Comment')}}" name="libraryComment"></exg-textarea>
        </div>
      </form>
    </div>
    <div class="spawn-modal-actions">
      <button class="md-btn" (click)="closeModal()" >{{getGlobal('Cancel')}}</button>
      <button class="md-btn" [disabled]="inputForm.invalid" (click)="saveLibrary()">{{getGlobal('Save')}}</button>
    </div>
  </div>
</div>
